import script from "./dance.vue?vue&type=script&setup=true&lang=js"
export * from "./dance.vue?vue&type=script&setup=true&lang=js"

import "./dance.vue?vue&type=style&index=0&id=3a26879f&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a26879f"]])

export default __exports__